/**
 * Developer Tools — a club's own API keys, and the documentation for using
 * them.
 *
 * THE NAME MOVED HERE on 2026-08-30 (Ben). It used to be the staff route
 * inventory, which is now "Manage API". This is the screen a customer's
 * engineer opens, and Developer Tools is what that screen is called
 * everywhere else in the industry.
 *
 * WHO SEES WHICH KEYS is decided by the server, not here: a club admin sees
 * every key the club holds, including the service keys that outlive whoever
 * made them; anyone else sees only their own. /api/v1/settings/api-tokens
 * enforces that, and this screen only draws what it returns.
 */
import ApiReference from '../components/api/ApiReference'
import TabStrip from '../components/api/TabStrip'
import ApiTokens from './ApiTokens'
import './admin.css'

export default function DeveloperTools() {
  return (
    <>
      <h1 className="page-title">Developer Tools</h1>
      <p className="page-sub">
        API keys for this club, and the reference for calling the API with them.
      </p>
      <TabStrip label="Developer tools sections" tabs={[
        { id: 'keys', label: 'API keys', body: () => <ApiTokens /> },
        { id: 'reference', label: 'Documentation',
          body: () => <ApiReference scope="club" /> },
      ]} />
    </>
  )
}
